import {
    ANCHOR_TOP,
    USER_REPLACE,
    EMAIL_REPLACE,
    COMPANY_REPLACE,
    CONFIRM_LINK_REPLACE,
} from "const"
import { Dispatch } from "redux"
import { useSelector } from "react-redux"
import {
    StoreType,
    setUrlOrigin,
    renderContent,
    renderProjectContent,
} from "client/store"

export const deepCopy = (obj: any) => (
    JSON.parse(JSON.stringify(obj))
)

export const replaceHistoryState = (
    url: string,
    state?: any,
) => {
    window.history.replaceState(state || null, "", url)
}

export const forceRerenderContent = (path: string, dispatch: Dispatch) => {
    replaceHistoryState(path)
    dispatch(setUrlOrigin(path))
    dispatch(renderContent(false))
    setTimeout(() => {
        dispatch(renderContent(true))
    }, 0)
}

export const forceRerenderProjectContent = (path: string, dispatch: Dispatch) => {
    replaceHistoryState(path)
    dispatch(setUrlOrigin(path))
    dispatch(renderProjectContent(false))
    setTimeout(() => {
        dispatch(renderProjectContent(true))
    }, 0)
}

export const scrollToTop = () => {
    const anchor = document.getElementById(ANCHOR_TOP)
    anchor.scrollIntoView({ block: "start", behavior: "smooth" })
}

export const randomString = (length: number): string => {
    let result = ""
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
}

export const randomNumber = (length: number) => {
    let result = ""
    for (let i = 0; i < length; i++) {
        const rand = Math.floor(Math.random() * 10) // random in range [0, 10]
        result = `${result}${rand}`
    }
    return Number(result)
}

export interface TextPlaceholders {
    user?: string
    email?: string
    company?: string
    confirmLink?: string
}

export const replacePlaceholders = (
    text: string,
    placeholders: TextPlaceholders,
) => {
    const userReplace = new RegExp(USER_REPLACE, "g")
    const emailReplace = new RegExp(EMAIL_REPLACE, "g")
    const companyReplace = new RegExp(COMPANY_REPLACE, "g")
    const confirmLinkReplace = new RegExp(CONFIRM_LINK_REPLACE, "g")

    return text
    .replace(userReplace, placeholders.user ? placeholders.user : "")
    .replace(emailReplace, placeholders.email ? placeholders.email : "")
    .replace(companyReplace, placeholders.company ? placeholders.company : "")
    .replace(
        confirmLinkReplace,
        placeholders.confirmLink ? `<a href="${placeholders.confirmLink}">${placeholders.confirmLink}</a>` : "",
    )
}

export const qidIsOpened = () => {
    const companyView = useSelector((state: StoreType) => state.qidCompany.companyView)
    const productView = useSelector((state: StoreType) => state.qidProduct.productView)

    let qidOpened = false
    if (companyView && companyView.id) qidOpened = true
    if (productView && productView.id) qidOpened = true

    return qidOpened
}
